import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { selectCanDo } from 'src/app/core/store/permissions/permissions.selectors';
import { Subscription } from 'rxjs';
import { HasPermissionContext } from 'src/app/shared/has-permission.directive';

@Component({
  selector: 'app-edit-basic-catalogs-infos',
  templateUrl: './edit-basic-catalogs-infos.component.html',
  styleUrls: ['./edit-basic-catalogs-infos.component.scss']
})
export class EditBasicCatalogsInfosComponent implements OnInit {
  form!: FormGroup;
  disableDate!: boolean;
  imageCatalog!: string;
  catalogImgFile!: File | undefined;
  defaultVariantAvatar: string = '../../../../../assets/images/uoload-image.jpeg'
  baseUrl = environment.BASE_URL_API
  canSubmit = false;
  isEdit = false;
  private subscriptions: Subscription[] = [];
  constructor(
    public dialogRef: MatDialogRef<EditBasicCatalogsInfosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: new FormControl(this.data?.name ?? '', Validators.required),
      start_date: new FormControl(this.data?.start_date ?? '', [this.validateStartDate.bind(this), Validators.required]),
      end_date: new FormControl(this.data?.end_date ?? '', [this.validateEndDate.bind(this)]),
      status: new FormControl(this.data?.status ?? 'Draft', Validators.required),
    });
    this.imageCatalog = this.data?.image
    this.disableDate = !!this.data.end_date
    this.isEdit = !!this.data?.isEdit;
    const action = this.isEdit ? 'edit' : 'create';
    const sub = this.store.select(selectCanDo('catalog', action)).subscribe((canSubmit) => {
      this.canSubmit = canSubmit;
      canSubmit ? this.form.enable({ emitEvent: false }) : this.form.disable({ emitEvent: false });
    });
    this.subscriptions.push(sub);
    this.onToggleChange();
  }

  validateStartDate(control: any) {
    if (!control.value) {
      return null;
    }

    const today = new Date();
    const startDate = new Date(control.value);

    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);

    if (this.data && this.data.start_date) {
      const existingStartDate = new Date(this.data.start_date);
      existingStartDate.setHours(0, 0, 0, 0);

      if (startDate.getTime() === existingStartDate.getTime()) {

        return null;
      }
    }


    return startDate >= today ? null : { startDateInvalid: true };
  }


  validateEndDate(control: any) {
    if (!this.form) {
      return null;
    }
    if (!control.value) {
      return null;
    }
    const startDate = new Date(this.form.get('start_date')?.value);
    const endDate = new Date(control.value);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate >= startDate ? null : { endDateInvalid: true };
  }

  getCatalogImg(event: any) {
    if (!this.canSubmit) return;
    let file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const dataUrl = e.target.result
        this.imageCatalog = dataUrl.split(',')[1]
        this.catalogImgFile = file;

      };
      reader.readAsDataURL(file);
    }
  }

  cancelImage(){
    if (!this.canSubmit) return;
    this.imageCatalog = '';
    this.catalogImgFile = undefined;
  }

  onToggleChange(){
    const endDateControle = this.form.get('end_date');
    if(!this.disableDate){
      endDateControle?.reset()
      endDateControle?.disable()
    } else {
      endDateControle?.enable()
    }
  }

  save(): boolean | void{
    if (!this.canSubmit) return;
    if(!this.form.valid){
      this.form.markAllAsTouched();
      return false
    };
    this.dialogRef.close({
      name: this.form.get('name')?.value,
      start_date: this.form.get('start_date')?.value,
      end_date: this.form.get('end_date')?.value,
      status: this.form.get('status')?.value,
      image: this.imageCatalog,
      catalogImgFile: this.catalogImgFile
    })
  }

  closed(){
    this.dialogRef.close()
  }

  submitPermission(): HasPermissionContext {
    return { module: 'catalog', action: this.isEdit ? 'edit' : 'create' };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

}
